import React, { useEffect, useRef, useState } from 'react';
import ChartContainer from './ChartContainer';
import { TradeChartSectionWrapper } from './styles';
import TradeChartNavBar from './TradeChartNavBar';
import { useTradeModalStore } from '../../../../hooks/trade/modalStore';
import DepthContainer from './DepthContainer';

const TradeChartSection = ({ isDragging }) => {
  const { data: modalStore, mutate: mutateModalStore } = useTradeModalStore();
  const initialTab = localStorage.getItem('CHART_TIMETAB') || '1m';

  const tabs = modalStore?.tabs
    ? modalStore?.tabs
    : ['1m', '5m', '15m', '30m', '1h', '1d', '1w', '1M'];

  const chartType = modalStore?.chartType;

  if (!modalStore?.tabs) mutateModalStore({ ...modalStore, tabs: tabs });

  return (
    <TradeChartSectionWrapper>
      {/* <TradeChartNavBar tab={tab} setTab={setTab} tabs={tabs} /> */}
      {chartType === 'depth' ? (
        <DepthContainer />
      ) : (
        <ChartContainer tab={initialTab} isDragging={isDragging} />
      )}
    </TradeChartSectionWrapper>
  );
};

export default React.memo(TradeChartSection);
